import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'gatsby';
import Container from 'modules/common/Container';
import ArrowLeft from 'modules/common/Svg/ArrowLeft';
import {bgColor} from './styles.scss';

const BreadCrumbs = ({steps}) => (
  <div className={`mb3 ph4 pt4 pb4-ns pb3 f6 ${bgColor}`}>
    <Container>
      <ul className="list cf pa0 ma0">
        {steps.map(({text, url}, index) => {
          const last = index === steps.length - 1;
          return (
            <li className="fr-ns ml3 link dim" key={`breadcrumb-${index}`}>
              <Link
                to={url}
                className={`dib silver pb0-ns pb3 ${last ? 'blue' : ''}`}
              >
                {text}
              </Link>
              {!last && (
                <span className="mr3-ns mr2">
                  <ArrowLeft />
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </Container>
  </div>
);

BreadCrumbs.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default BreadCrumbs;
